import { render } from "./QuantitySelector.vue?vue&type=template&id=2fa8a482&scoped=true"
import script from "./QuantitySelector.vue?vue&type=script&lang=js"
export * from "./QuantitySelector.vue?vue&type=script&lang=js"

import "./QuantitySelector.vue?vue&type=style&index=0&id=2fa8a482&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa8a482"]])

export default __exports__